// ⬡B:ms_mac_core.Smoke:CODE:ms_mac_persona_clone_fix:20260607⬡
// Animated smoke background. Extracted from apps/msria-home/src/Chat.jsx.
import React from 'react';

export function Smoke() {
  return (
    <>
      <div className="ria-smoke" style={{
        position: 'fixed', inset: '-25%', zIndex: 0, pointerEvents: 'none',
        background:
          'radial-gradient(38% 32% at 28% 24%, rgba(232,150,170,.20), transparent 70%),' +
          'radial-gradient(44% 40% at 76% 36%, rgba(176,108,120,.16), transparent 72%),' +
          'radial-gradient(50% 46% at 50% 84%, rgba(94,34,48,.30), transparent 76%),' +
          'radial-gradient(70% 60% at 50% 50%, rgba(18,14,20,.85), #07070a 82%)',
        filter: 'blur(12px)', animation: 'riaburn 56s ease-in-out infinite alternate',
      }} />
      <style>{'@keyframes riaburn{0%{transform:scale(1.06)}50%{transform:scale(1.18) translate(-2%,-1%)}100%{transform:scale(1.1) translate(1.5%,1%)}}@media(prefers-reduced-motion:reduce){.ria-smoke{animation:none!important}}'}</style>
    </>
  );
}
